import { Constants } from '@leverege/molten-core';
import MapSupport from "./MapSupport.js";
import ZoomIn from "./actions/ZoomIn.js";
import ZoomOut from "./actions/ZoomOut.js";
import Satellite from "./actions/Satellite.js";
import TimeRange from "./actions/TimeRange.js";
import MapEditSettingsAction from "./actions/MapEditSettingsAction.js";
import RendererSetup from "./renderers/PluginSetup.js";
import MapViewerEditor from "./models/MapViewerEditor.js";
import MapProvider from "./MapProvider.js";
import MapDataViewer from "./MapDataViewer.js";
import BaseMapViewModelUpdater from "./BaseMapViewModelUpdater.js";
import MapViewerModel from "../shared/models/MapViewerModel.js";
const install = molten => {
  molten.addPlugin(Constants.SUPPORT_COMPONENTS, MapSupport);
  molten.addPlugin('DataViewer', MapDataViewer);
  molten.addPlugin('Action', MapEditSettingsAction);
  molten.addPlugin('Action', ZoomIn);
  molten.addPlugin('Action', ZoomOut);
  molten.addPlugin('Action', Satellite);
  molten.addPlugin('Action', TimeRange);
  molten.addPlugin('Model', {
    type: MapViewerModel.TYPE,
    model: MapViewerModel
  });
  molten.addPlugin('ModelEditor', {
    type: MapViewerModel.TYPE,
    editor: MapViewerEditor
  });
  molten.addPlugin('MapViewModelUpdater', BaseMapViewModelUpdater);
  RendererSetup.install(molten);
  molten.set('MapProvider', MapProvider);
};
export default {
  install
};